// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { type StyledComponent } from '@emotion/styled';
import { grid } from '../style-utils';
import { itemHighlightColor } from '../item-highlight-color';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import type { Theme } from '@emotion/react';
import type { DetailedHTMLProps, HTMLAttributes, ClassAttributes } from 'react';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ResultLink } from './result-link';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { IconContainer } from './icon-container';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { EnlargedIconContainer } from './enlarged-icon-container';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ResultTitleContainer } from './result-title-container';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { EnlargedResultTitleContainer } from './enlarged-result-title-container';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ResultLabel } from './result-label';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ResultDetail } from './result-detail';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { CollapsedResultDetail } from './collapsed-result-detail';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { EnlargedCollapsedResultDetail } from './enlarged-collapsed-result-detail';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { EnlargedResultTitleContainerSkeleton } from './enlarged-result-title-container-skeleton';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { EnlargedResultDetail } from './enlarged-result-detail';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { EnlargedResultDetailSkeleton } from './enlarged-result-detail-skeleton';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { CollapsedResultDetailWrapper } from './collapsed-result-detail-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { EnlargedCollapsedResultDetailWrapper } from './enlarged-collapsed-result-detail-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { DetailsSeparator } from './details-separator';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { CollapsedResultContentWrapper } from './collapsed-result-content-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ResultContentButtonWrapper } from './result-content-button-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { EnlargedSkeletonIcon } from './enlarged-skeleton-icon';

interface ResultLinkProps {
	isCollapsed?: boolean;
	isKeyboardHighlighted?: boolean;
	isQuickFind?: boolean;
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const ResultContentWrapper: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles
	} & ResultLinkProps,
	DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
	{}
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
> = styled.div<ResultLinkProps>((props) => ({
	display: 'flex',
	width: '100%',
	alignItems: 'center',
	position: 'relative',
	boxSizing: 'border-box',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: grid.multiple(props.isCollapsed ? 5 : 4).px,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	padding: `0 ${grid.twice().px}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: props.isKeyboardHighlighted ? itemHighlightColor : 'transparent',
	'&:hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		backgroundColor: itemHighlightColor,
	},
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const EnlargedResultContentWrapper: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles
	} & ResultLinkProps,
	DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
	{}
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
> = styled.div<ResultLinkProps>((props) => ({
	display: 'flex',
	width: '100%',
	alignItems: 'center',
	position: 'relative',
	boxSizing: 'border-box',
	borderRadius: token('radius.medium'),
	padding: `${token('space.075')} ${token('space.100')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: props.isKeyboardHighlighted ? itemHighlightColor : 'transparent',
	'&:hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		backgroundColor: itemHighlightColor,
	},
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const ReturnIconContainer: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles
	} & ResultLinkProps,
	DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
	{}
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
> = styled.div<ResultLinkProps>((props) => ({
	borderRadius: token('radius.small'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	margin: grid.half().px,
	marginRight: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: grid.multiple(3).px,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: grid.twice().px,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	right: grid.multiple(1.5).px,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	top: props.isCollapsed ? grid.px : grid.half().px,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	opacity: props.isKeyboardHighlighted ? 1 : 0,
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EnlargedReturnIconContainer: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
	} & ResultLinkProps,
	DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
	{}
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.div<ResultLinkProps>({
	width: token('space.300'),
	height: token('space.300'),
	marginLeft: token('space.150'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ShowAllResultsReturnIconContainer: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
	} & ResultLinkProps &
		ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> & {
			theme?: Theme;
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
		},
	{},
	{}
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled(ReturnIconContainer)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: grid.multiple(2.5).px,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: grid.multiple(2.5).px,
	opacity: 1,
});
